import React from 'react';
import { DelayType, MockService, ResponseDelay } from '../types/rest/mockServiceTypes';
import { MockServiceTemplate } from '../store/mockServiceTemplates/mockServiceTemplateTypes';
import _ from 'lodash';

export const formattedText = (message: string, item: string) => {
  return (
    <div>
      {message} <span className={'font-weight-semi-bold'}>{item}</span>.
    </div>
  );
};

export const formattedTextMultiArgs = (
  firstMessage: string,
  secondMessage: string,
  firstItem: string,
  secondItem: string,
) => {
  return (
    <div>
      {firstMessage} <span className={'font-weight-semi-bold'}> {firstItem}</span> {secondMessage}
      <span className={'font-weight-semi-bold'}>{secondItem}</span>.
    </div>
  );
};

export const formattedTextMulti = (
  firstMessage: string,
  secondMessage: string,
  thirdMessage: string,
  fourthMessage: string,
  firstItem: string,
  secondItem: string,
  thirdItem: string,
) => {
  return (
    <div>
      {firstMessage} <span className={'font-weight-semi-bold'}> {firstItem}</span> {secondMessage}
      <span className={'font-weight-semi-bold'}>{secondItem}</span>.{thirdMessage}{' '}
      <span className={'font-weight-semi-bold'}>{thirdItem}</span> {fourthMessage}.
    </div>
  );
};

export const formattedTextThreeArgs = (firstMessage: string, secondMessage: string, firstItem: string) => {
  return (
    <div>
      {firstMessage} <span className={'font-weight-semi-bold'}> {firstItem}</span> {secondMessage}
    </div>
  );
};

//substring by character(s) starting after specific number of occurrences
export const subByOccurrence = (str: string, subStr: any, occurrence: number) => {
  const position = str.split(subStr, occurrence).join(subStr).length;
  return str.substring(position);
};

//substring path from domain, starts the 3rd time '/' appears
export const getPath = (url: string) => {
  return subByOccurrence(url, '/', 3);
};

/**
 * Processes think time delay in the patch dto.
 * @param patchDto
 * @param originalMockService
 */
export const processThinkTime = (patchDto: any, originalMockService: MockService | MockServiceTemplate) => {
  // Response delay adjustments - send all the correspondent fields to the type selected
  if (
    patchDto.responseDelay !== undefined &&
    patchDto.responseDelay !== null &&
    originalMockService.responseDelay !== undefined
  ) {
    const rd: ResponseDelay = _.cloneDeep(originalMockService.responseDelay);
    patchDto.responseDelay.type = rd.type;
    switch (rd.type) {
      case DelayType.FIXED:
        patchDto.responseDelay.duration = rd.duration;
        break;
      case DelayType.UNIFORM:
        patchDto.responseDelay.lower = rd.lower;
        patchDto.responseDelay.upper = rd.upper;
        break;
      case DelayType.LOGNORMAL:
        patchDto.responseDelay.sigma = rd.sigma;
        patchDto.responseDelay.median = rd.median;
        break;
    }
  }

  return patchDto;
};

/**
 * Gets focus on the field by ref.
 */
export const handleFocus = (currentRef: any) => {
  if (currentRef != null) {
    setTimeout(() => {
      currentRef.focus();
    }, 100);
  }
};

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'OPTIONS' | 'PATCH' | 'TRACE' | 'HEAD' | 'CONNECT' | 'ANY';

export const methodColors = {
  GET: '#0C7BB3',
  POST: '#3f9e20',
  PUT: '#cc8304',
  DELETE: '#ba2d1e',
  PATCH: '#188f85',
  OPTIONS: '#4a5aa8',
  TRACE: '#3272d9',
  HEAD: '#864cb0',
  CONNECT: '#333840',
  ANY: '#333840',
};

/**
 * Returns span element with colored HTTP method.
 */
export const getColoredHttpMethod = (httpMethod: HttpMethod) => {
  if (_.isNil(httpMethod)) {
    return <></>;
  }
  const color = methodColors[httpMethod];
  return <span style={{ color: color }}>{httpMethod}</span>;
};

export const convertToNumber = (number: string | number) => {
  //Base needs to be set manually to 10 otherwise it might be considered as hexadecimal if # is prefixed with 0
  return parseInt(number as string, 10);
};
